module.exports = __webpack_public_path__ + "static/com_5-6459160a8831bad186e6ce6114155361.jpg";